import * as React from "react";
import {ChangeEvent, ReactElement} from "react";
import {getDays, getMonths, getYears, OptionType} from "../../../config/pax";
import {selectionDate} from "../../../typings/bookingEngine/bookingEngine";

type BirthDateSelectionProps = {
    date: selectionDate;
    index: number;
    onDayChange: (value: string, index: number) => void;
    onMonthChange: (value: string, index: number) => void;
    onYearChange: (value: string, index: number) => void;
    children?: React.ReactNode;

};

const BirthDateSelection = (props: BirthDateSelectionProps): ReactElement => {

    const days = getDays(props.date.month.value, props.date.year.value);
    const months: OptionType[] = getMonths();
    const years: OptionType[] = getYears();
    const hasChildren = !!props.children;

    return (
        <div className="children-item">
            <div className="label">Date de naissance de l'enfant {props.index + 1}</div>
            <div className="row">
                <div className="col-4">
                    <div className="select-wrap">
                        <select className="input-style select" id={`childBirthday_${props.index}`}
                            onChange={(event: ChangeEvent<HTMLSelectElement>) => props.onDayChange(event.currentTarget.value, props.index)}
                            defaultValue={props.date.day.value}
                        >
                            {days.map((day: OptionType) => (<option key={day.value} value={day.value}>{day.label}</option>))}
                        </select>
                    </div>
                </div>
                <div className="col-4">
                    <div className="select-wrap">
                        <select className="input-style select" id={`childBirthMonth_${props.index}`}
                            onChange={(event: ChangeEvent<HTMLSelectElement>) => props.onMonthChange(event.currentTarget.value, props.index)}
                            defaultValue={props.date.month.value}
                        >
                            {months.map((month: OptionType) => (<option key={month.value} value={month.value}>{month.label}</option>))}
                        </select>
                    </div>
                </div>
                <div className="col-4">
                    <div className="select-wrap">
                        <select className="input-style select" id={`childBirthYear_${props.index}`}
                            onChange={(event: ChangeEvent<HTMLSelectElement>) => props.onYearChange(event.currentTarget.value, props.index)}
                            defaultValue={props.date.year.value}
                        >
                            {years.map((year: OptionType) => (<option key={year.value} value={year.value}>{year.label}</option>))}
                        </select>
                    </div>
                </div>
                {hasChildren && props.children}
            </div>
        </div>
    );
};

export default BirthDateSelection;